<template>
  <ul v-if="activeVolume" class="flex items-start">
    <li class="inline-block mr-[8px] relative">
      <router-link
        :to="{
          name: 'HubWithVolume',
          params: {
            volumeSlug: activeVolume.slug,
          },
        }"
        class="button bg-white hover:bg-hover text-orange-500 block px-[15px] py-[12px] z-10"
        >X</router-link
      >
    </li>
    <menu-section
      v-if="calendarItems?.length"
      title="Kalender"
      :items="calendarItems"
      :to="{
        name: 'CalendarSheet',
        params: {
          seasonSlug: activeSeason.slug,
        },
      }"
    />
    <menu-section
      v-if="filmItems?.length"
      title="Film"
      :items="filmItems"
      :to="{
        name: 'FilmList',
        params: {
          seasonSlug: activeSeason.slug,
        },
      }"
    />
    <menu-section
      v-if="activeSchoolLevel?.archivedVideos?.length"
      title="Filmarchief"
      :to="{
        name: 'FilmArchive',
      }"
    />
    <menu-section
      v-if="musicItems?.length"
      title="Muziek"
      :items="musicItems"
      :to="{
        name: 'SongList',
        params: {
          seasonSlug: activeSeason.slug,
        },
      }"
    />
    <menu-section
      v-if="activeSchoolLevel?.archivedSongs?.length"
      title="Muziekarchief"
      :to="{
        name: 'MusicArchive',
      }"
    />
    <menu-section
      v-if="materialItems?.length"
      title="Materiaal"
      :items="materialItems"
      :to="{
        name: 'MaterialContentWithSeason',
        params: {
          seasonSlug: activeSeason.slug,
        },
      }"
    />
    <menu-section
      v-if="extraItems?.length"
      title="Extra"
      :items="extraItems"
      :to="{
        name: 'ExtraContentWithSeason',
        params: {
          seasonSlug: activeSeason.slug,
        },
      }"
    />
  </ul>
</template>

<script>
import { mapGetters } from "vuex";

import { RouterLink } from "vue-router";

import findByReferenceSlug from "../../store/getters/resolve/find-by-reference-slug";

import MenuSection from "../../components/MenuSection.vue";

const findSeasonContentForSchoolLevel = (season, schoolLevel) =>
  findByReferenceSlug(
    season.seasonContentForSchoolLevel,
    "schoolLevel",
    schoolLevel.slug,
  );

export default {
  name: "SectionMenu",
  components: {
    MenuSection,
    RouterLink,
  },
  computed: {
    ...mapGetters(["activeVolume", "activeSchoolLevel", "activeSeason"]),
    calendarItems() {
      return this.getSectionItems("days", "CalendarSheet");
    },
    filmItems() {
      return this.getSectionItems("videos", "FilmList");
    },
    musicItems() {
      return this.getSectionItems("songs", "SongList");
    },
    materialItems() {
      return this.getSectionItems(
        (seasonContentForSchoolLevel) =>
          (seasonContentForSchoolLevel?.materialTitleYear &&
            seasonContentForSchoolLevel?.materialContentYear.length) ||
          (seasonContentForSchoolLevel?.materialTitleIssue &&
            seasonContentForSchoolLevel?.materialContentIssue.length) ||
          (seasonContentForSchoolLevel?.materialTitleHoliday &&
            seasonContentForSchoolLevel?.materialContentHoliday.length),
        "MaterialContentWithSeason",
      );
    },
    extraItems() {
      return this.getSectionItems("extraContent", "ExtraContentWithSeason");
    },
  },
  methods: {
    getSectionItems(section, itemRoute) {
      if (!this.activeSchoolLevel) {
        return null;
      }
      const now = new Date();

      return (
        this.activeVolume?.seasons
          .filter((season) => {
            // Only visible seasons.
            if (
              season.frontendDisplayStartDate &&
              new Date(season.frontendDisplayStartDate) > now
            ) {
              return false;
            }
            if (
              season.frontendDisplayEndDate &&
              new Date(season.frontendDisplayEndDate) < now
            ) {
              return false;
            }

            const seasonContentForSchoolLevel = findSeasonContentForSchoolLevel(
              season,
              this.activeSchoolLevel,
            );

            // Allow section to be a callback ot evaluate
            // the `seasonContentForSchoolLevel` properties.
            return section instanceof Function
              ? section(seasonContentForSchoolLevel)
              : !!seasonContentForSchoolLevel?.[section].length;
          })
          // Transform into menu items.
          .map((season) => ({
            key: season.slug,
            title: `${this.activeVolume.title} / ${season.issueNumber}`,
            to: {
              name: itemRoute,
              params: {
                seasonSlug: season.slug,
              },
            },
          }))
      );
    },
  },
};
</script>
